// extracted by mini-css-extract-plugin
export default {"container":"LogoWithMessage_container__PBzWj"};